import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import {
	INTERACTION_TYPE,
	ITEM_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { IContact } from 'app/interfaces/contact.interface';
import { ICalendarEvent } from 'app/interfaces/event.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';

@Component({
	selector: 'appointment-details-header',
	templateUrl: './appointment-details-header.component.html',
	styleUrls: ['./appointment-details-header.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class AppointmentDetailsHeaderComponent {
	@Input()
	public contact: IContact;

	@Input()
	public event: ICalendarEvent;

	@Input()
	public isFirstSession = false;

	constructor(
		public router: Router,
		public actionTrackerService: ActionTrackerService
	) {}

	public openContactDetails(from: string): void {
		this.actionTrackerService.eventTracker(
			SCOPE_TYPE.Appointment,
			SUBSCOPE_TYPE.Details,
			ITEM_TYPE.BtnContact,
			INTERACTION_TYPE.Click,
			{
				from: from,
			}
		);
		this.router.navigateByUrl(`/contact/${this.event.contactId}`);
	}
}
